import github from '../../assets/github.png';

import '../../styles/days.scss';

const Ten = () => (
  <div className='days full-image rounded'>
    <img src={github} alt='github contributions' />
  </div>
);

export default Ten;
